module.exports = __webpack_public_path__ + "media/images/faq/3-100-11d6f509f141d3e860c17f64dd2ee2ea.jpg";